import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {AppComponent} from './app.component';

import {AuthentificationService} from './authentification.service';
import {ProductsAbstractService} from './products-abstract.service';
import {ProductsArticleService} from './products-article.service';
import {ProductsCategoryService} from './products-category.service';
import {StocksService} from './stocks.service';

import {ProductsCategory} from './products-category';
import {ProductsLotAbstract} from './products-lot-abstract';
import {ProductsMovementAbstract} from './products-movement-abstract';

import {StockAvailibilityService} from './stock-availibility.service';

@Component({
    selector: 'app-stock-availibility',
    templateUrl: './templates/stock-status.component.html',
    styleUrls: ['./styles/stock-status.component.css'],
    providers: [ProductsCategoryService, ProductsArticleService, StocksService, ProductsAbstractService, AuthentificationService, StockAvailibilityService]
})
export class StockStatusComponent implements OnInit {
    category: string = "ankerana";

    warehouses_list: ProductsCategory[];
    position: string = 'before';

    hide_lot_infos: boolean = false;

    stock_availibility: Array<any> = [];

    lot_abstract: ProductsLotAbstract[];
    prod_list: ProductsMovementAbstract[];

    info_article: string;

    tmp: number;
    item: string;

    movement_list: ProductsMovementAbstract[] = [];
    total: Object = {
        entree: '',
        sortie: ''
    };
    date: Object = {
        min: '',
        max: ''
    };

    internal_code: any = '';

    mode: Array<any> = [
        {mode_value: '0', move_view: 'Article'},
        {mode_value: '1', move_view: 'Emplacement'}
    ];
    mode_view: any = '0';

    ngOnInit(): void {
        this.getWarehousesList();
        this.getStockAvailibility();
    }

    constructor(
        private app_component: AppComponent,
        private router: Router,
        private stock_availibility_service: StockAvailibilityService,
        private authentification_service: AuthentificationService) {
        this.checkUserSession();

        this.app_component.valTest = '/stock-status';
        this.app_component.GetParent();
    }

    checkUserSession(): void {
        this.authentification_service.UserCheckSession()
            .then(result => {
                if (result['id_user'] === 0) {
                    this.router.navigate(['authentification']);
                }
            });
    }

    changed(event: any) {
        this.prod_list = [];
        this.movement_list = [];
        this.tmp = -1;
        this.info_article = '';
        this.mode_view = event;
        this.getStockAvailibility();
    }

    getStockAvailibility(): void {
        this.stock_availibility_service.getStockAvailibility(this.mode_view)
            .then(result => {
                this.stock_availibility = result['list'];
            });
    }

    getWarehousesList(): void {
        this.stock_availibility_service.getWarehouses()
            .then(result => {
                this.warehouses_list = result['list'];
            });
    }

    getDetailsByItem(): void {
        this.stock_availibility_service.getDetailsByItem(this.item, this.category)
            .then(result => {
                this.prod_list = result['list'];
            });
    }

    getArticlesLotInfos(article: any, i: number): void {
        this.detailsMouvementWarehouse(article, 'true');
        if (this.tmp === i) {
            this.hide_lot_infos = true;
            this.tmp = -1;
            this.hide_lot_infos = false;
        } else {
            this.item = article.internal_code;
            this.getDetailsByItem();
            this.tmp = i;
        }
    }

    detailsMouvementWarehouse(prod: any, warehouses: any) {
        this.internal_code = prod.internal_code;
        this.show_sites = false;
        var index = this.stock_availibility.findIndex(supplier => supplier.internal_code === prod.internal_code);
        this.selected = index;
        console.log(this.selected);
        this.movement_list = [];
        var entrepot = '';
        if (this.category === undefined) {
            entrepot = warehouses;
        } else {
            entrepot = this.category;
        }
        this.stock_availibility_service.detailsMouvementWarehouse(prod.internal_code, entrepot)
            .then(response => {
                this.movement_list = response['list']['response'];
                this.total = response['list']['total'];
                this.date = response['list']['date'];
            });
        if (warehouses === 'true') {
            this.info_article = '(' + prod.name + ' - Stock : ' + prod.stock + ')';
        } else {
            this.info_article = '(' + warehouses + ' : ' + prod.name + ' - Stock : ' + prod.stock + ')';
        }
    }

    selected: any = -1;
    SetStyle(value: any) {
        let styles = {
            'background-color': '',
            'color': 'black',
        };
        if (value == this.selected) {
            styles = {
                'background-color': 'rgb(120,120,120)',
                'color': 'white',
            };
        }
        return styles;
    }

    SetStyle2(value: any) {
        let styles = {
            'padding-left': (10 * Number(value)) + 'px;'
        };
        return styles;
    }
    all = -1;

    show_sites: boolean = false;
    SetDetailsMvtStyle() {
        //console.log(this.show_sites);
        let styles = {
            'height': '82vh'
        };
        if (this.show_sites == true) {
            styles = {
                'height': '35vh'
            };
        }
        return styles;
    }

    ToggleSites() {
        if (this.show_sites == false) {
            this.show_sites = true;
            this.ShowStockStatusFromOtherSites();
        } else {
            this.show_sites = false;
        }
    }

    list_other_sites: Array<any> = [];
    ShowStockStatusFromOtherSites() {
        this.stock_availibility_service.ShowStockStatusFromOtherSites(this.internal_code)
            .then(response => {
                this.list_other_sites = response['list'];
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/stock-status.component.ts